import React from "react";
import trackingService from "../../services/trackingService";
import { TrackingEvents } from "../../services/trackingEvents";
import { CLAUDE_CONNECTOR_URL, ClaudeConnectorContext } from "./claudeConnectorConfig";

export function ClaudeLogo({ className = "h-5 w-5" }: { className?: string }) {
  return <img src="https://www.runplutus.com/provider-assets/1/claude.svg" alt="" aria-hidden="true" className={`shrink-0 ${className}`} />;
}

export function ClaudeConnectorLink({
  context,
  placement,
  compact = false,
  showLogo = true,
}: {
  context: ClaudeConnectorContext;
  placement: "header" | "discover-row" | "product-strip" | "settings-card" | "share-header";
  compact?: boolean;
  showLogo?: boolean;
}) {
  return (
    <a
      href={CLAUDE_CONNECTOR_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackingService.track(TrackingEvents.CLAUDE_CONNECTOR_CLICKED, { context, placement })}
      className={`inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-v7-control border border-v7-ink bg-v7-ink font-medium text-v7-white transition-colors hover:bg-v7-ink-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-v7-bronze-dark ${compact ? "min-h-8 px-3 py-1.5 text-[11px]" : placement === "discover-row" ? "min-h-10 px-3.5 py-2 text-[13px]" : "min-h-11 px-4 py-2.5 text-sm"}`}
    >
      {showLogo && <ClaudeLogo />}
      {compact ? "Set up Plutus connector" : "Connect Claude"}
    </a>
  );
}
